/* import __COLOCATED_TEMPLATE__ from './secondary.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'small',
  classNames: ['option__label--secondary'],
  attributeBindings: ['data-test-option-label-text'],
  'data-test-option-label-text': 'secondary'
});